import script from "./UserAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAuth.vue?vue&type=script&setup=true&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=5dce8113&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dce8113"]])

export default __exports__